import styled from 'styled-components';
import {getFontSize, getSpacing} from '@tickchak/react-share/app';
import {dFlex, flexWrap, alignStart} from '../../../../../../globalVariables/GlobalFlex';

export const container = styled.div`
    padding: 20px 0;
    width: 100%;
`;

export const title = styled.div`
    font-size: ${getFontSize('body')};
    padding-bottom: ${getSpacing('spaceMd')};
`;

export const contacts = styled.div`
    ${dFlex}
    ${flexWrap}
    ${alignStart}
    gap: ${getSpacing('spaceMd')};
`;

export const popupWrap = styled.div`
    position: relative;
`;
